import React, { Component } from "react";
import Select from "react-select";

class SelectSearch extends Component {
  state = {
    objValue: null,
  };

  componentDidUpdate(prevProps) {
    // console.log(
    //   "this.props.value,  typeof this.props.value",
    //   this.props.value,
    //   typeof this.props.value
    // );
    if (prevProps.value !== this.props.value && this.props.value !== "") {
      this.setState({
        objValue:
          typeof this.props.value === "object"
            ? this.props.value
            : {
                name: this.props.value,
                value: this.props.value,
              },
      });
    }
  }
  customStyles = {
    indicatorSeparator: (styles) => ({ display: "none" }),
    option: (provided, state) => ({
      ...provided,
      "&:hover": {
        backgroundColor: "rgb(95, 50, 187, 10%)",
        color: "#621ac0",
      },

      color: state.isSelected ? "#621ac0" : "black",
      backgroundColor: state.isSelected
        ? "rgb(95, 50, 187, 10%)"
        : provided.backgroundColor,
      //backgroundColor: state.isSelected ? "rgb(95, 50, 187, 10%)" : "white",
    }),
    control: (base, state) => ({
      ...base,
      height: 55,
      minHeight: 55,
      borderColor: state.isFocused ? "#6119c0" : "#e0e0e0",
      boxShadow: "0 !important",
      "&:hover": {
        borderColor: "#6119c0",
      },
      "&:focus": {
        borderColor: "#6119c0",
      },
      //backgroundColor: state.isDisabled ? "#aaa" : "white",
    }),
    multiValueRemove: (base, state) => ({
      ...base,
      "&:hover": {
        backgroundColor: "rgb(95, 50, 187, 10%)",
        color: "#6119c0",
      },
    }),
  };

  render() {
    const { name, options, label, error, value, defaultValue, ...rest } =
      this.props;

    return (
      <div className="form-group custom-input">
        <Select
          isDisabled={this.props.isDisabled}
          {...rest}
          onChange={(a) =>
            this.props.onChange({
              name: name,
              currentTarget:
                name === "time" || name === "date"
                  ? a
                  : { value: a.value, name: a.name },
            })
          }
          value={this.state.objValue}
          className="basic-single"
          classNamePrefix="select-search"
          getOptionLabel={(option) => option.name}
          getOptionValue={(option) => option.name}
          name={name}
          options={options}
          placeholder={label}
          styles={this.customStyles}
        />
        {error && <label className="error">{error}</label>}
      </div>
    );
  }
}

export default SelectSearch;
